import { Text as ChakraText, TextProps as ChakraTextProps } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';

const TextStyles: ComponentStyleConfig = {
  baseStyle: {
    fontWeight: 'normal',
    color: 'base2FontColour.500',
    letterSpacing: 'normal',
  },
  variants: {
    second: {
      pl: 1,
      fontWeight: 'bold',
    },
  },
};

const Text = ({ children, as, variant, ...props }: ChakraTextProps) => (
  <ChakraText as={variant === 'first' || variant === 'second' ? 'span' : as} variant={variant} {...props}>
    {children}
  </ChakraText>
);

export { Text, TextStyles };
